// extracted by mini-css-extract-plugin
module.exports = {"debug":"Header_debug__1k7lF","header":"Header_header__21pfI","center":"Header_center__1XSGw"};